export const entityLegalFormCodeToEntityLegalType = {
  5599: 'SA',
  5605: 'SA',
  5610: 'SA',
  5615: 'SA',
  5620: 'SA',
  5622: 'SA',
  5625: 'SA',
  5630: 'SA',
  5631: 'SA',
  5632: 'SA',
  5642: 'SA',
  5643: 'SA',
  5646: 'SA',
  5647: 'SA',
  5648: 'SA',
  5651: 'SA',
  5652: 'SA',
  5653: 'SA',
  5654: 'SA',
  5655: 'SA',
  5658: 'SA',
  5659: 'SA',
  5660: 'SA',
  5670: 'SA',
  5685: 'SA',
  5699: 'SA',
  5710: 'SAS',
  5770: 'SAS',
  5785: 'SAS',
  5800: 'AUT',
  6100: 'AUT',
  6210: 'GIE',
  6220: 'GIE',
  6316: 'SCA',
  6317: 'SCA',
  6318: 'SCA',
  7314: 'PUBLIC',
  7321: 'PUBLIC',
  7322: 'PUBLIC',
  7323: 'PUBLIC',
  7331: 'PUBLIC',
  7340: 'PUBLIC',
  7341: 'PUBLIC',
  7342: 'PUBLIC',
  7343: 'PUBLIC',
  7344: 'PUBLIC',
  6411: 'AUT',
  6511: 'SCI',
  6521: 'SCI',
  6532: 'SCI',
  6533: 'SCI',
  6534: 'SCI',
  6535: 'SCI',
  6536: 'SCI',
  6537: 'SCI',
  6538: 'SCI',
  6539: 'SCI',
  6540: 'SCI',
  6541: 'SCI',
  6542: 'SCI',
  6543: 'SCI',
  6544: 'SCI',
  6551: 'SCI',
  6554: 'SCI',
  6558: 'SCI',
  6560: 'SCI',
  6561: 'SCI',
  6562: 'SCI',
  6563: 'SCI',
  6564: 'SCI',
  6565: 'SCI',
  6566: 'SCI',
  6567: 'SCI',
  6568: 'SCI',
  6569: 'SCI',
  6571: 'SCI',
  6572: 'SCI',
  6573: 'SCI',
  6574: 'SCI',
  6575: 'SCI',
  6576: 'SCI',
  6577: 'SCI',
  6578: 'SCI',
  6585: 'SCI',
  6589: 'SCI',
  6595: 'SCI',
  6596: 'SCI',
  6597: 'SCI',
  6598: 'SCI',
  6599: 'SCI',
  6901: 'AUT',
  7111: 'PUBLIC',
  7112: 'PUBLIC',
  7113: 'PUBLIC',
  7120: 'PUBLIC',
  7150: 'PUBLIC',
  7160: 'PUBLIC',
  7171: 'PUBLIC',
  7172: 'PUBLIC',
  7179: 'PUBLIC',
  7190: 'PUBLIC',
  7210: 'PUBLIC',
  7220: 'PUBLIC',
  7225: 'PUBLIC',
  7229: 'PUBLIC',
  7230: 'PUBLIC',
  7312: 'PUBLIC',
  7313: 'PUBLIC',
  7345: 'PUBLIC',
  7346: 'PUBLIC',
  7347: 'PUBLIC',
  7348: 'PUBLIC',
  7349: 'PUBLIC',
  7351: 'PUBLIC',
  7352: 'PUBLIC',
  7353: 'PUBLIC',
  7354: 'PUBLIC',
  7355: 'PUBLIC',
  7356: 'PUBLIC',
  7357: 'PUBLIC',
  7361: 'PUBLIC',
  7362: 'PUBLIC',
  7363: 'PUBLIC',
  7364: 'PUBLIC',
  7365: 'PUBLIC',
  7366: 'PUBLIC',
  7367: 'PUBLIC',
  7371: 'PUBLIC',
  7372: 'PUBLIC',
  7373: 'PUBLIC',
  7378: 'PUBLIC',
  7379: 'PUBLIC',
  7381: 'PUBLIC',
  7382: 'PUBLIC',
  7383: 'PUBLIC',
  7384: 'PUBLIC',
  7385: 'PUBLIC',
  7389: 'PUBLIC',
  7410: 'AUT',
  7430: 'AUT',
  7450: 'AUT',
  7470: 'AUT',
  7490: 'AUT',
  8110: 'ASSO',
  8120: 'ASSO',
  8130: 'ASSO',
  8140: 'ASSO',
  8150: 'ASSO',
  8160: 'ASSO',
  8170: 'ASSO',
  8190: 'ASSO',
  8210: 'ASSO',
  8250: 'ASSO',
  8290: 'ASSO',
  8310: 'ASSO',
  8311: 'ASSO',
  8410: 'ASSO',
  8420: 'ASSO',
  8450: 'ASSO',
  8470: 'ASSO',
  8490: 'ASSO',
  8510: 'ASSO',
  8520: 'ASSO',
  9110: 'ASSO',
  9150: 'ASSO',
  9210: 'ASSO',
  9220: 'ASSO',
  9221: 'ASSO',
  9222: 'ASSO',
  9223: 'ASSO',
  9224: 'ASSO',
  9230: 'ASSO',
  9240: 'ASSO',
  9260: 'ASSO',
  9300: 'ASSO',
  9900: 'AUT',
  9970: 'AUT',
  5470: 'SARL',
  0: 'AUT',
  1000: 'EI',
  2110: 'INDIV_PP',
  2120: 'INDIV_PM',
  2210: 'AUT',
  2220: 'AUT',
  2310: 'AUT',
  2320: 'AUT',
  2385: 'AUT',
  2400: 'AUT',
  2700: 'AUT',
  2900: 'AUT',
  3110: 'ETR',
  3120: 'ETR',
  3205: 'ETR',
  3210: 'ETR',
  3220: 'ETR',
  3290: 'ETR',
  4110: 'PUBLIC',
  4120: 'PUBLIC',
  4130: 'PUBLIC',
  4140: 'PUBLIC',
  4150: 'PUBLIC',
  4160: 'PUBLIC',
  5191: 'AUT',
  5192: 'AUT',
  5193: 'AUT',
  5194: 'AUT',
  5195: 'AUT',
  5196: 'AUT',
  5202: 'SNC',
  5203: 'SNC',
  5306: 'SC',
  5307: 'SC',
  5308: 'SC',
  5309: 'SC',
  5310: 'SC',
  5370: 'SC',
  5385: 'SC',
  5410: 'SARL',
  5415: 'SARL',
  5422: 'SARL',
  5426: 'SARL',
  5430: 'SARL',
  5431: 'SARL',
  5432: 'SARL',
  5442: 'SARL',
  5443: 'SARL',
  5451: 'SARL',
  5453: 'SARL',
  5454: 'SARL',
  5455: 'SARL',
  5458: 'SARL',
  5459: 'SARL',
  5460: 'SARL',
  5485: 'SARL',
  5499: 'SARL',
  5505: 'SA',
  5510: 'SA',
  5515: 'SA',
  5520: 'SA',
  5522: 'SA',
  5525: 'SA',
  5530: 'SA',
  5531: 'SA',
  5532: 'SA',
  5542: 'SA',
  5543: 'SA',
  5546: 'SA',
  5547: 'SA',
  5548: 'SA',
  5551: 'SA',
  5552: 'SA',
  5553: 'SA',
  5554: 'SA',
  5555: 'SA',
  5558: 'SA',
  5559: 'SA',
  5560: 'SA',
  5570: 'SA',
  5585: 'SA',
};
